/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Eu_Hosted_TooltipInputs */



/**
* | output |
* | --- |
* | "Hosted in Europe - your data stays in the EU" |
*
* @param {Model_Eu_Hosted_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_eu_hosted_tooltip = /** @type {((inputs?: Model_Eu_Hosted_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Eu_Hosted_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In Europa gehostet - Ihre Daten bleiben in der EU")
	return /** @type {LocalizedString} */ ("Hosted in Europe - your data stays in the EU")
});